import { Building2, MapPin, Phone } from 'lucide-react';

export default function Banks() {
    const banks = [
        {
            name: 'Commercial Bank of Ethiopia',
            address: 'Arat Kilo, Addis Ababa',
            phone: '+251 11 551 7438',
            mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.340123456789!2d38.7577!3d9.0320!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOcKwMDEnNTUuMiJOIDM4wrA0NSczMi44IkU!5e0!3m2!1sen!2sus!4v1234567890'
        },
        {
            name: 'Awash Bank',
            address: 'Meskel Square, Addis Ababa',
            phone: '+251 11 663 2525',
            mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.340123456789!2d38.7577!3d9.0320!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOcKwMDEnNTUuMiJOIDM4wrA0NSczMi44IkU!5e0!3m2!1sen!2sus!4v1234567890'
        },
        {
            name: 'Dashen Bank',
            address: 'Churchill Avenue, Addis Ababa',
            phone: '+251 11 551 5005',
            mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.340123456789!2d38.7577!3d9.0320!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOcKwMDEnNTUuMiJOIDM4wrA0NSczMi44IkU!5e0!3m2!1sen!2sus!4v1234567890'
        },
        {
            name: 'Bank of Abyssinia',
            address: 'Mexico Square, Addis Ababa',
            phone: '+251 11 551 4300',
            mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.340123456789!2d38.7577!3d9.0320!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOcKwMDEnNTUuMiJOIDM4wrA0NSczMi44IkU!5e0!3m2!1sen!2sus!4v1234567890'
        },
        {
            name: 'Wegagen Bank',
            address: 'Bole Road, Addis Ababa',
            phone: '+251 11 662 6565',
            mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.340123456789!2d38.7577!3d9.0320!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOcKwMDEnNTUuMiJOIDM4wrA0NSczMi44IkU!5e0!3m2!1sen!2sus!4v1234567890'
        },
        {
            name: 'United Bank',
            address: 'Haile Gebreselassie Road, Addis Ababa',
            phone: '+251 11 553 8300',
            mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.340123456789!2d38.7577!3d9.0320!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOcKwMDEnNTUuMiJOIDM4wrA0NSczMi44IkU!5e0!3m2!1sen!2sus!4v1234567890'
        }
    ];

    return (
        <div className="min-h-screen pt-24 pb-20">
            <section className="bg-gradient-to-br from-emerald-800 to-emerald-900 text-white py-20">
                <div className="container mx-auto px-4">
                    <div className="max-w-3xl mx-auto text-center">
                        <h1 className="text-5xl font-bold mb-6">
                            Our Partner Banks
                        </h1>
                        <p className="text-xl text-emerald-50">
                            We partner with trusted banks across Ethiopia to ensure your money reaches your loved ones safely.
                        </p>
                    </div>
                </div>
            </section>

            <section className="py-12 bg-gray-50">
                <div className="container mx-auto px-4">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                        {banks.map((bank, index) => (
                            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition">
                                <div className="p-6 border-b border-gray-200 bg-emerald-50">
                                    <div className="flex items-center gap-3">
                                        <div className="bg-emerald-800 p-3 rounded-lg">
                                            <Building2 className="w-6 h-6 text-white" />
                                        </div>
                                        <h3 className="text-2xl font-bold text-emerald-900">{bank.name}</h3>
                                    </div>
                                </div>

                                <div className="p-6 space-y-4">
                                    <div className="flex items-start gap-3">
                                        <MapPin className="w-5 h-5 text-emerald-800 mt-1 flex-shrink-0" />
                                        <div>
                                            <p className="text-sm font-semibold text-gray-700">Address</p>
                                            <p className="text-gray-600">{bank.address}</p>
                                        </div>
                                    </div>

                                    <div className="flex items-start gap-3">
                                        <Phone className="w-5 h-5 text-emerald-800 mt-1 flex-shrink-0" />
                                        <div>
                                            <p className="text-sm font-semibold text-gray-700">Phone</p>
                                            <a href={`tel:${bank.phone}`} className="text-emerald-800 hover:text-emerald-600 transition">
                                                {bank.phone}
                                            </a>
                                        </div>
                                    </div>

                                    <div className="mt-6">
                                        <div className="aspect-video rounded-lg overflow-hidden">
                                            <iframe
                                                src={bank.mapUrl}
                                                width="100%"
                                                height="100%"
                                                style={{ border: 0 }}
                                                allowFullScreen
                                                loading="lazy"
                                                referrerPolicy="no-referrer-when-downgrade"
                                                className="w-full h-full"
                                            ></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="py-12 bg-white">
                <div className="container mx-auto px-4">
                    <div className="max-w-3xl mx-auto text-center">
                        <h2 className="text-3xl font-bold text-emerald-900 mb-6">
                            More Banks Coming Soon
                        </h2>
                        <p className="text-lg text-gray-600 mb-8">
                            We're constantly expanding our network of partner banks to provide you with more convenient options for your money transfers.
                        </p>
                        <a
                            href="/contact"
                            className="inline-block bg-yellow-500 text-emerald-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-yellow-400 transition transform hover:scale-105"
                        >
                            Contact Us for More Info
                        </a>
                    </div>
                </div>
            </section>
        </div>
    );
}
